// extracted by mini-css-extract-plugin
module.exports =  {"updateBrandIdBlock":"updateBrandIdBlock__OY6Q4"};